var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLikeGrid(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icLikeGrid") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 18,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-9.7%",
    y: "-6.9%",
    width: "119.4%",
    height: "119.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.68436897,10.7437869 C6.43725731,13.0677437 6.43983042,16.7984553 8.68436897,19.1242509 L17.8495981,28.6231189 C17.9396086,28.7171558 18.0648173,28.7704344 18.1958006,28.7704344 C18.3267839,28.7704344 18.4519927,28.7171558 18.5420031,28.6231189 C21.6000021,25.4605104 24.6566434,22.2942995 27.7146662,19.1316204 C29.9617779,16.8076236 29.9617779,13.0751391 27.7146662,10.7511447 C25.4675783,8.4271526 21.7942481,8.4271008 19.5471363,10.7511447 L18.1995173,12.1417596 L16.8519222,10.7437869 C15.7283544,9.58178971 14.2436696,9 12.7644169,9 C11.2851643,9 9.80791293,9.58178736 8.68436897,10.7437869 Z M13.0139161,10.0891832 C14.1699883,10.0891832 15.3758842,10.8715493 16.2711353,11.7974225 L17.8757902,13.4597059 C17.9608763,13.5486046 18.079239,13.5989726 18.203061,13.5989726 C18.326883,13.5989726 18.4452457,13.5486046 18.5303318,13.4597059 L20.2743653,11.449193 C22.5765951,9.32617867 25.3518381,9.94567827 27.1423178,11.7974225 C28.9327749,13.6491645 28.3299882,16.650451 26.5395311,18.5021952 C23.7588498,21.3780262 20.9801951,24.2577744 18.1995364,27.1335609 L9.85956471,18.4952512 C8.07041392,16.6413258 7.62385968,13.3008949 9.41433924,11.449193 C10.3095678,10.523322 11.8578438,10.0891832 13.0139161,10.0891832 Z",
    id: "path-4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icLikeGrid",
    transform: "translate(2.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#91E359",
    fillRule: "nonzero",
    xlinkHref: "#path-4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLikeGrid);
export default __webpack_public_path__ + "static/media/icLikeGrid.3c9013766d0ca76cec9ac91158cf668d.svg";
export { ForwardRef as ReactComponent };